import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/SystemBanner/sgds-system-banner-item";
import { register } from "../../utils/ce-registry";

register("sgds-system-banner-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-system-banner-item",
  elementClass: Component,
  events: {
    onSgdsShowMore: "sgds-show-more"
  }
});
